import createStore from "zustand";
import { devtools } from "zustand/middleware";
import { configurePersist } from "zustand-persist";

const { persist, purge } = configurePersist({
  storage: localStorage, // use `AsyncStorage` in react native
  rootKey: "root", // optional, default value is `root`
});

const useBuyFactorStore = createStore(
  persist(
    {
      key: "BuyFactor",
    },
    (set) => ({
      factorID: 0,
      setFactorID: (currentID) => set(() => ({ factorID: currentID })),
      productID: 0,
      setProductID: (currentID) => set(() => ({ productID: currentID })),
      date: 0,
      setDate: (currentDate) => set(() => ({ date: currentDate })),
      productName: "",
      setProductName: (currentproductName) =>
        set(() => ({ productName: currentproductName })),
    })
  )
);
export default useBuyFactorStore;
